"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Empty = void 0;

var _react = _interopRequireDefault(require("react"));

var _ri = require("react-icons/ri");

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Empty = function Empty(_ref) {
  var children = _ref.children,
      icon = _ref.icon;
  var Icon = icon ? icon : _ri.RiFolderUnknowLine;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: rootCSS
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    as: Icon,
    size: 40,
    extend: iconCSS
  }), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
    size: 2
  }), /*#__PURE__*/_react["default"].createElement(_.Text, {
    diffuse: true
  }, children));
};

exports.Empty = Empty;

var rootCSS = function rootCSS(_ref2) {
  var grid = _ref2.theme.grid;
  return {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: "".concat(8 * grid, "px ").concat(4 * grid, "px"),
    textAlign: 'center'
  };
};

var iconCSS = function iconCSS(_ref3) {
  var colors = _ref3.theme.colors;
  return {
    color: colors.diffuse
  };
};